// extracted by mini-css-extract-plugin
module.exports = {"hasMargin":"FullWidthImage-module--hasMargin--1gS2q"};